var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStatusGear24Px = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87733 11.2839L7.70007 11.084C7.37876 10.7217 7.32536 10.1944 7.56748 9.77504L7.8569 9.27375C8.09902 8.8544 8.58233 8.63702 9.05673 8.73411L9.31856 8.78769C9.57711 8.84059 9.84609 8.79694 10.0746 8.66498V8.66498C10.3032 8.53303 10.4755 8.32192 10.5589 8.07156L10.6434 7.81807C10.7965 7.35869 11.2264 7.04883 11.7107 7.04883H12.2895C12.7737 7.04883 13.2037 7.35869 13.3568 7.81807L13.4413 8.07156C13.5247 8.32192 13.697 8.53303 13.9256 8.66498V8.66498C14.1541 8.79694 14.4231 8.84059 14.6816 8.78769L14.9435 8.73411C15.4179 8.63704 15.9012 8.85442 16.1433 9.27378L16.4327 9.77506C16.6748 10.1944 16.6214 10.7217 16.3001 11.084L16.1228 11.2839C15.9477 11.4813 15.851 11.7361 15.851 12V12C15.851 12.264 15.9477 12.5187 16.1228 12.7162L16.3001 12.9161C16.6214 13.2784 16.6748 13.8057 16.4326 14.225L16.1432 14.7263C15.9011 15.1457 15.4178 15.3631 14.9434 15.266L14.6815 15.2124C14.423 15.1595 14.1541 15.2031 13.9255 15.3351V15.3351C13.697 15.467 13.5247 15.6781 13.4413 15.9285L13.3567 16.182C13.2036 16.6414 12.7737 16.9513 12.2895 16.9513H11.7107C11.2264 16.9513 10.7965 16.6414 10.6434 16.182L10.5589 15.9285C10.4754 15.6781 10.3031 15.467 10.0746 15.3351V15.3351C9.84607 15.2031 9.57714 15.1595 9.31862 15.2124L9.0567 15.266C8.5823 15.3631 8.09901 15.1457 7.8569 14.7263L7.56748 14.225C7.32536 13.8057 7.37876 13.2784 7.70007 12.9161L7.87735 12.7162C8.05245 12.5187 8.14914 12.2639 8.14913 12V12C8.14913 11.7361 8.05244 11.4814 7.87733 11.2839Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.0002,
    r: 7.91667,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0001,
    cy: 12.0003,
    r: 1.45833,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStatusGear24Px);
export default ForwardRef;